module.exports = __webpack_public_path__ + "Flag-804.48a8c1c77eff09606285873a7cedb876.svg";